// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"d0e9c94d","357":"1bd2bbe4"}[chunkId] + ".chunk.css";
};